import { INDEED_DESCRIPTION } from "../actions/types";
import { ConsoleLogger } from "aws-amplify/utils";

/* eslint-disable */
const logger = new ConsoleLogger("JOB.REDUCER");
/* eslint-enable */

export const jobReducer = (state = {}, action) => {
  switch (action.type) {
    
    case INDEED_DESCRIPTION: {
        let indeed_description = state.indeed_description || {};
        let desc = action.description;
        let id = action.id;
  
        indeed_description[id] = desc;
  
        return {
          ...state,
          indeed_description: indeed_description
        }
    }

    default:
      return state;
  }
};
